import React, { ButtonHTMLAttributes } from 'react';

import styles from './IconButton.module.scss';
import {
  DesignSystemIconButtonSize,
  DesignSystemIconButtonVariant,
  getIconButtonClasses,
  getIconButtonIconSize,
  getIconButtonIconTone,
} from './utils';
import { Icon } from '../Icon/Icon';
import { DesignSystemIconName, DesignSystemIconTone } from '../Icon/utils';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  'aria-label': string;
  icon: DesignSystemIconName;
  variant?: DesignSystemIconButtonVariant;
  size?: DesignSystemIconButtonSize;
  isActive?: boolean;
  isLoading?: boolean;
  iconTone?: DesignSystemIconTone;
};

export const IconButton = ({
  icon,
  variant = DesignSystemIconButtonVariant.GHOST,
  size = DesignSystemIconButtonSize.MEDIUM,
  isActive,
  isLoading,
  iconTone,
  className,
  disabled,
  ...props
}: Props): JSX.Element => {
  const isDisabled = Boolean(disabled || isLoading);

  return (
    <button
      type="button"
      className={getIconButtonClasses({
        variant,
        size,
        isActive,
        isLoading,
        disabled,
        className,
      })}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-pressed={isActive}
      {...props}
    >
      {isLoading ? (
        <span className={styles.loader} />
      ) : (
        <Icon
          name={icon}
          size={getIconButtonIconSize(size)}
          tone={iconTone || getIconButtonIconTone({ variant, disabled })}
        />
      )}
    </button>
  );
};

export type { Props as IconButtonProps };
